angular.module('ecrd').controller('RecordQueriesController', [
    '$exceptionHandler',
    '$window',
    '$rootScope',
    '$state',
    'RecordQueriesService',
    'RecordDataService',
    'RecordService',
    'CrfService',
    'InetsysMessages',
    'gettext',
    'gettextCatalog',
    'RecordsManagerService',
    'AccountManager',
    'StudyContext',
    'Event',
    'Modal',
    'ErrorMessages',
    'QueriesListUtilities',
    function(
        $exceptionHandler,
        $window,
        $rootScope,
        $state,
        RecordQueriesService,
        RecordDataService,
        RecordService,
        CrfService,
        InetsysMessages,
        gettext,
        gettextCatalog,
        RecordsManagerService,
        AccountManager,
        StudyContext,
        Event,
        Modal,
        ErrorMessages,
        QueriesListUtilities
    ) {
        var vm = this;

        // Permisos generales, a.k.a routes
        vm.permission = {
            read: AccountManager.hasPermission('read records queries'),
            create: AccountManager.hasPermission('create records queries'),
            reply: AccountManager.hasPermission('reply records queries'),
            close: AccountManager.hasPermission('close records queries'),
        };
        // Permisos según el ámbito del registro que estamos viendo
        vm.context = {
            read: StudyContext.canWithQueries('read'),
            create: StudyContext.canWithQueries('create'),
            reply: StudyContext.canWithQueries('reply'),
            close: StudyContext.canWithQueries('close'),
        };

        vm.filters = {};
        vm.order = 'created_at_desc';

        // Entity notes
        var getQueries = function() {
            vm.queriesList = RecordQueriesService.getQueries();
            vm.metainfo = RecordQueriesService.getMetaInfo();
        };

        getQueries();

        var getStateName = function(fieldUId) {
            var state = 'record.edit.data';
            var element = CrfService.getElementByUID(fieldUId);
            var form = element.getForm();
            var lists = element.getParentLists();
            lists.forEach(function(list) {
                state = state + '.' + list.getPathFromList().join('.') + '.item';
            });

            return state + '.' + form.getPathFromList().join('.');
        };

        var applyFilters = function() {
            if (vm.queries) {

                if (vm.filters) {
                    if (vm.filters.status) {
                        vm.queries = vm.queries.filter(function(item) {
                            return vm.filters.status === 'open'
                                ? item.query.lastText.status !== 'closed'
                                : item.query.lastText.status === vm.filters.status;
                        });
                    }

                    if (vm.filters.type) {
                        vm.queries = vm.queries.filter(function(item) {
                            return vm.filters.type === 'manual'
                                ? item.query.firstText.type === 'manual'
                                : item.query.firstText.type !== 'manual';
                        });
                    }

                    if (vm.filters.lastReply) {
                        vm.queries = vm.queries.filter(function(item) {
                            return vm.filters.lastReply === 'internal'
                                ? item.query.lastText.inSite
                                : !item.query.lastText.inSite;
                        });
                    }
                }

                if (vm.order) {
                    switch (vm.order) {
                        case 'created_at_asc':
                            vm.queries = vm.queries.sort(function(itemA, itemB) {
                                return itemA.daysOpen - itemB.daysOpen;
                            }).reverse();
                            break;

                        case 'created_at_desc':
                            vm.queries = vm.queries.sort(function(itemA, itemB) {
                                return itemA.daysOpen - itemB.daysOpen;
                            });
                            break;
                        case 'last_reply_asc':
                            vm.queries = vm.queries.sort(function(itemA, itemB) {
                                return itemA.daysSinceLastReply - itemB.daysSinceLastReply;
                            }).reverse();
                            break;
                        case 'last_reply_desc':
                            vm.queries = vm.queries.sort(function(itemA, itemB) {
                                return itemA.daysSinceLastReply - itemB.daysSinceLastReply;
                            });
                            break;
                    }
                }
            }

            vm.hasFilters = Object.values(vm.filters).filter(function(filter) {
                return filter !== '';
            }).length;
        };

        var uid, listIndices, stateParams, replyIndex;
        var listQueries = function() {
            // indexado por UID
            vm.queries = [];

            for (uid in vm.queriesList) {
                var fieldQueries = vm.queriesList[uid];

                if (!fieldQueries || fieldQueries.length === 0) {
                    // GARU-3863 Si la lista está vacía no se calculan las queries del campo
                    continue;
                }

                listIndices = RecordDataService.getListIndicesByUID(uid);
                stateParams = CrfService.getNamedListIndices(listIndices);

                var queryObj = {
                    stateHref: vm.metainfo[uid].exists ? $state.href(getStateName(uid), stateParams) : null,
                    stateParams: stateParams,
                };

                fieldQueries.forEach(function(query) {
                    var queryCopy = angular.copy(queryObj);
                    var endDate = query.lastText.status === 'closed' ? query.lastText.createdAt : null;

                    queryCopy.query = query;
                    queryCopy.daysOpen = QueriesListUtilities.getDiffDays(query.firstText.createdAt, endDate);
                    queryCopy.daysSinceLastReply = query.lastText.createdAt ? QueriesListUtilities.getDiffDays(query.lastText.createdAt) : '-',

                    query.labelChanged = !$window._.isEqual(query.fieldLabel, vm.metainfo[uid].label);

                    for (replyIndex = 0; replyIndex < query.texts.length; replyIndex++) {
                        query.texts[replyIndex].labelChanged = query.texts[replyIndex].fieldLabel && !$window._.isEqual(query.texts[replyIndex].fieldLabel, vm.metainfo[uid].label);
                    }

                    vm.queries.push(queryCopy);
                });
            }

            applyFilters();

            vm.hasQueries = !!vm.queries.length;
        };

        listQueries();

        // Visibilidad de las notas padre (las que inician una cadena de respuestas luego)
        // Indexado por UID del campo
        vm.visibility = {};
        vm.toggleFieldQueries = function(field) {
            vm.visibility[field.uid] = !vm.visibility[field.uid];
        };

        // Visibilidad del contenido de una nota concreta (para desplegar una nota padre)
        // Indexado por ID de la query padre
        vm.queriesVisibility = {};
        vm.toggleQueriesContent = function(queryId) {
            vm.queriesVisibility[queryId] = !vm.queriesVisibility[queryId];
        };

        // Responder a una nota de discrepancia
        vm.replyNote = function(query, field) {
            if (query.lastText.status === 'closed') {
                return;
            }

            // Allow others to stop this action before it is launched
            return Event.broadcast('discrepancyNotesActionStart', [vm.fieldId, 'reply'])
                .then(function(event) {
                    if (!event.defaultPrevented) {
                        // Open form in modal
                        return Modal
                            .open({
                                controller: 'FieldReplyQueryController',
                                controllerAs: '$ctrl',
                                templateUrl: 'modules/ecrd/components/field/queries/reply-modal/content.html',
                                onlyActions: true,
                                resolve: {
                                    query: function() {
                                        return query;
                                    },
                                },
                            })
                            .closePromise
                            // 'Submit' button pressed - Call server to reply note
                            .then(function(queryData) {
                                // var fieldUId = RecordDataService.getElementUID(vm.fieldId, listIndices);
                                var params = {
                                    queryId: query.id,
                                    status: queryData.status,
                                    text: queryData.text,
                                };

                                return RecordsManagerService.replyQuery(params);
                            })
                            .catch(function(error) {
                                // 'Cancel' button pressed - nothing to do
                                if (error !== Modal.DISMISSED) {
                                    InetsysMessages.error({
                                        mode: 'modal',
                                        title: gettext('No se ha podido responder la nota de discrepancia'),
                                        body: ErrorMessages.get(error),
                                    });
                                }

                                throw error;
                            })
                            .then(function(response) { // eslint-disable-line no-unused-vars
                                // initNotesData();

                                // Success message
                                InetsysMessages.success({
                                    title: gettext('Nota de discrepancia actualizada'),
                                });

                                return RecordsManagerService.getQueries(RecordService.getId());
                            })
                            .then(function(recordQueries) {

                                RecordQueriesService.load(recordQueries);

                                getQueries();
                                listQueries();

                                // angular.extend(vm.fields[field.uid], vm.metainfo[field.uid]);
                                // Trigger event: info updated
                                $rootScope.$broadcast('EntityNotesUpdated');
                            });
                    }
                })
                .catch(function(error) {
                    return $exceptionHandler(error, 'reply query');
                });
        };

        vm.closeNote = function(query, field) {
            if (query.lastText.status === 'closed') {
                return;
            }

            // Allow others to stop this action before it is launched
            return Event.broadcast('discrepancyNotesActionStart', [vm.fieldId, 'close'])
                .then(function(event) {
                    if (!event.defaultPrevented) {
                        // Open form in modal
                        return Modal
                            .open({
                                controller: 'FieldCloseQueryController',
                                controllerAs: '$ctrl',
                                templateUrl: 'modules/ecrd/components/field/queries/close-modal/content.html',
                                onlyActions: true,
                                resolve: {
                                    query: function() {
                                        return query;
                                    },
                                },
                            })
                            .closePromise
                            // 'Submit' button pressed - Call server to close note
                            .then(function(data) {
                                // var fieldUId = RecordDataService.getElementUID(vm.fieldId, listIndices);
                                var params = {
                                    queryId: query.id,
                                    // status: 'closed',
                                    text: data.text,
                                };

                                return RecordsManagerService.closeQuery(params);
                            })
                            .catch(function(error) {
                                // 'Cancel' button pressed
                                if (error !== Modal.DISMISSED) {
                                    InetsysMessages.error({
                                        mode: 'modal',
                                        title: gettext('No se ha podido responder la nota de discrepancia'),
                                        body: ErrorMessages.get(error),
                                    });
                                }

                                throw error;
                            })
                            .then(function(response) {
                                // initNotesData();

                                // Success message
                                InetsysMessages.success({
                                    title: gettext('Nota de discrepancia actualizada'),
                                });

                                return RecordsManagerService.getQueries(RecordService.getId());
                            })
                            .then(function(recordQueries) {
                                RecordQueriesService.load(recordQueries);
                                getQueries();
                                listQueries();
                                // angular.extend(vm.fields[field.uid], vm.metainfo[field.uid]);
                                // Trigger event: info updated
                                $rootScope.$broadcast('EntityNotesUpdated');
                            });
                    }
                })
                .catch(function(error) {
                    return $exceptionHandler(error, 'close query');
                });
        };
        vm.buildSummary = function(text) {
            var summary;

            switch (text) {
                case 'field-required-value-not-specified':
                    summary = gettextCatalog.getString('El campo es obligatorio pero no se ha especificado ningún valor');
                    break;

                case 'closed-by-rule':
                    summary = gettextCatalog.getString('Cerrada por regla automática');
                    break;

                case 'field-required-has-value':
                    summary = gettextCatalog.getString('El campo obligatorio ya tiene un valor');
                    break;

                case 'field-required-no-longer-required':
                    summary = gettextCatalog.getString('El campo ha dejado de ser obligatorio');
                    break;

                case 'field-required-record-state-unset':
                    summary = gettextCatalog.getString('Se ha anulado el estado global');
                    break;

                case 'field-required-form-state-unset':
                    summary = gettextCatalog.getString('Se ha anulado el estado del formulario');
                    break;

                default:
                    summary = $window._(text).split('\n').truncate({
                        length: 90,
                        separator: /[, \t]+/g,
                    });
            }

            return summary;
        };

        vm.buildText = function(original) {
            var text;

            switch (original) {
                case 'field-required-value-not-specified':
                    text = gettextCatalog.getString('El campo es obligatorio pero no se ha especificado ningún valor');
                    break;

                case 'closed-by-rule':
                    text = gettextCatalog.getString('Cerrada por regla automática');
                    break;

                case 'field-required-has-value':
                    text = gettextCatalog.getString('El campo obligatorio ya tiene un valor');
                    break;

                case 'field-required-no-longer-required':
                    text = gettextCatalog.getString('El campo ha dejado de ser obligatorio');
                    break;

                case 'field-required-record-state-unset':
                    text = gettextCatalog.getString('Se ha anulado el estado global');
                    break;

                case 'field-required-form-state-unset':
                    text = gettextCatalog.getString('Se ha anulado el estado del formulario');
                    break;

                default:
                    text = original.split('\n').join('<br>');
            }

            return text;
        };

        vm.reloadQueries = function(filters, order) {
            vm.filters = filters;
            vm.order = order;
            listQueries();
        };
    },
]);
